export const API_KEY_GET_TESTIMONIALS_PRIORITY_OPTIONS =
  "API_KEY_GET_TESTIMONIALS_PRIORITY_OPTIONS";
